import React from 'react';
import { I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';
import SidebarMenusSection from './SidebarMenusSection';
import AdmMenusAction from '../../app/store/actions/admMenu';

class SidebarMenus extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      active: ['Checkbuy'],
      subActive: '',
    };
  }

  async componentDidMount() {
    if (this.props.menuState) {
      await this.setState({ active: this.props.menuState });
    } else {
      await this.props.getAdmMenuState();
      if (this.props.menuState) {
        await this.setState({ active: this.props.menuState });
      }
    }
  }

  isActive = (rec) => {
    const { active } = this.state;
    if (!Array.isArray(active)) return false;
    const idx = active.findIndex(element => element === rec);
    return (idx >= 0);
  }

  setActive = async (rec) => {
    const { active } = this.state;
    const idx = active.findIndex(element => element === rec);
    if (idx >= 0) {
      delete active[idx];
      await this.setState({ active });
    } else {
      active.push(rec);
      await this.setState({ active });
    }
    this.props.saveAdmMenuState(active);
  }

  setSub = () => {
    this.setState({ subActive: I18n.t('products') });
  }

  render() {
    const { active, subActive } = this.state;
    const { user, admMenuTree } = this.props;

    return (
      <ul className="nav">

        {admMenuTree && admMenuTree.map(subMenu => (
          <SidebarMenusSection
            key={subMenu.id}
            icon={subMenu.icon}
            menu={{
              label: subMenu.label,
            }}
            subMenus={subMenu.subMenus || []}
            isActive={this.isActive}
            setActive={this.setActive}
            countOfPendingRequests={this.props.countOfPendingRequests || 0}
            companyTag={this.props.companyTag}
          />
        ))}
      </ul>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  saveAdmMenuState: state => dispatch(AdmMenusAction.saveAdmMenuState(state)),
  getAdmMenuState: state => dispatch(AdmMenusAction.getAdmMenuState(state)),
});

const mapStateToProps = state => ({
  user: state.auth && state.auth.user,
  menuState: state.admMenus && state.admMenus.menuState,
  admMenuTree: state.admMenus && state.admMenus.admMenuTree,
  countOfPendingRequests: state.settings.countOfPendingRequests,
  companyTag: state.settings.companyTag,
});

export default connect(mapStateToProps, mapDispatchToProps)(SidebarMenus);
